/* ============================================================
   VIVĀRA — PURCHASE SELECTOR
   ------------------------------------------------------------
   Two top-level choices, one-time selected by default:

     One-Time Purchase   $88   → CTA "Add to Cart — $88"
     Subscribe & Save    $68   → CTA "Subscribe — $68"

   Selecting the subscription reveals the recurring-purchase disclosure
   (savings, interval, auto-renewal, cancellation) directly beneath the
   controls. Selecting one-time hides every recurring reference.

   The selling plan id is written into the hidden `selling_plan` field, so
   the same markup drives a one-time purchase and a subscription. On Shopify
   the form posts through the cart drawer; off Shopify nothing is simulated.

   SHOPIFY MIGRATION
   -----------------
   form[data-product-form]        → {% form 'product', product %}
   input[name="purchase-type"]    → selling_plan radio group
   [data-selling-plan]            → selling_plan_allocation.selling_plan.id
   [data-variant-id]              → variant id hidden input
   ============================================================ */
(function () {
  "use strict";

  function init() {
    var P = window.VIVARA_PRODUCT;
    if (!P) return;

    /* Shopify's {% form %} tag builds the <form> element itself, so the
       panel is also matched on its class. When the data attribute did not
       survive the tag, none of this ran: the selling plan field was never
       filled and every "subscription" reached the cart as a one-time. */
    document.querySelectorAll("[data-purchase], form.purchase").forEach(function (root) {
      var inputs = root.querySelectorAll('input[name^="purchase-type"]');
      if (!inputs.length) return;

      var ctaLabel = root.querySelector("[data-cta-label]");
      var ctaPrice = root.querySelector("[data-cta-price]");
      var cta = root.querySelector("[data-cta]");
      var recurring = root.querySelector("[data-recurring-terms]");
      var planInput = root.querySelector("[data-selling-plan]");

      function selected() {
        var v = "one-time";
        inputs.forEach(function (i) { if (i.checked) v = i.value; });
        return v;
      }

      function sync() {
        var type = selected();
        var subscribing = type === "subscribe";
        var price = subscribing ? P.subscriptionPrice : P.oneTimePrice;

        root.querySelectorAll(".option").forEach(function (opt) {
          var input = opt.querySelector("input");
          opt.classList.toggle("option--active", !!input && input.checked);
        });

        if (ctaLabel) ctaLabel.textContent = subscribing ? "Subscribe" : "Add to Cart";
        if (ctaPrice) ctaPrice.textContent = P.format(price);

        /* Recurring terms appear only for the subscription. */
        if (recurring) {
          recurring.hidden = !subscribing;
          recurring.setAttribute("aria-hidden", subscribing ? "false" : "true");
        }

        if (cta) {
          cta.setAttribute("data-purchase-type", type);
          cta.setAttribute("data-purchase-price", price.toFixed(2));
        }
        /* Shopify: empty selling plan = one-time purchase. */
        if (planInput) {
          var planId = planInput.getAttribute("data-plan-id") || P.sellingPlanId || "";
          planInput.value = subscribing ? planId : "";
        }
      }

      inputs.forEach(function (i) { i.addEventListener("change", sync); });
      sync();
    });

    /* The product form cannot submit until Shopify is connected. */
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (!form.getAttribute("action")) e.preventDefault();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
